import { ConversationId } from "@redotech/effect-api-shared/ids/definitions";
import { memo } from "react";
import { useParams } from "react-router-dom";
import { ConversationView } from "./views/conversation-view";

export const Support = memo(function Support() {
  const { conversationId: conversationIdString } = useParams<{
    conversationId: string;
  }>();

  if (!conversationIdString) {
    return <div>Select a conversation</div>;
  }

  const conversationId = ConversationId.make(conversationIdString);

  return <ConversationView conversationId={conversationId} />;
});
